import classNames from 'classnames/bind';
import styles from './TypographyElement.module.scss';
import { SxProps, Typography, TypographyProps, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { ColorTypographyElement } from '@/componentShare/theme/dark';
const cx = classNames.bind(styles);

export type FontSizeTypographyElement = '9px' | '12px' | '14px' | '16px' | '18px'
export type FontWeightTypographyElement = 400 | 500 | 600 | 700

interface TypographyElementProps extends TypographyProps {
    children: ReactNode,
    FontSizeElement?: FontSizeTypographyElement
    FontWeightElement?: FontWeightTypographyElement
    ColorElement?: ColorTypographyElement
    TextAlignElement?: "justify" | "center" | "left" | "right" | "start" | "end"
    isEllipsis?: boolean
}

export default function TypographyElement(props: TypographyElementProps) {
    const { FontSizeElement, FontWeightElement, ColorElement, TextAlignElement, isEllipsis, ...rest } = props
    const theme = useTheme()

    const ellipsis: SxProps = isEllipsis === true ? {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    } : {}

    const combineStyle = {
        fontSize: FontSizeElement ?? '14px',
        fontWeight: FontWeightElement ?? 400,
        color: ColorElement ? theme.palette.text[ColorElement] : theme.palette.text.primary,
        textAlign: TextAlignElement ?? 'start',
        ...ellipsis,
        ...props?.sx,
    }
    return (
        <Typography {...rest} sx={combineStyle}>
            {props.children}
        </Typography>
    )
}